import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YesNoInput from '../YesNoInput';
import NumberFieldInput from '../NumberFieldInput';

class YesNoNumberInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: props.selected,
      value: props.value,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value, property) {
    this.setState({
      [property]: value,
    });
  }

  render() {
    const {
      id,
      name,
      errors,
      numberPlaceholder,
      label,
    } = this.props;

    const {
      selected,
      value,
    } = this.state;

    return (
      <div>
        <YesNoInput
          id=""
          onAnswerChange={(val) => this.handleChange(val, 'selected')}
          value={selected}
          errors={errors}
        />

        <NumberFieldInput
          name={name}
          id={id}
          placeholder={numberPlaceholder}
          value={selected === 'Yes' ? value : 0}
          displayNumberFieldInput={selected === 'Yes'}
          onAnswerChange={(val) => this.handleChange(val, 'value')}
          label={label}
        />
      </div>
    );
  }
}

YesNoNumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  selected: PropTypes.oneOf(['Yes', 'No', null]),
  errors: PropTypes.shape({}),
  name: PropTypes.string,
  numberPlaceholder: PropTypes.string,
  value: PropTypes.number,
  label: PropTypes.string,
};

YesNoNumberInput.defaultProps = {
  selected: null,
  numberPlaceholder: '',
  value: null,
  label: '',
  errors: {},
  name: '',
};

export default YesNoNumberInput;
